// Hand-written content for the Madrid city page (/guides/spain/madrid/). See lisbon.js for how the fields work.
// Facts: from the guides' own stop lists, or well-established history. No prices, hours or restaurants.

const madrid = {
  name: 'Madrid',
  aliases: ['Madrid'],
  heroImage: 'guide:palace',
  heroTagline: 'Kings, painters and a city built for a court.',
  lead: '{n} self-guided audio tours for Madrid: the Royal Palace and Plaza Mayor, the masterpieces of the Prado and the chapel Goya painted. Play them on your phone, walk at your own pace, and ask the guide anything along the way.',

  startHere: ['palace', 'prado', 'goya'],

  guides: [
    { key: 'palace', title: 'Royal Palace & Plaza Mayor',
      versions: { en: 'royal-palace-plaza-mayor-flames-power-and-tragedy-in-madrid', es: 'palacio-real-y-plaza-mayor-llamas-poder-y-tragedia-en-madrid', pt: 'palacio-real-plaza-mayor-chamas-poder-e-tragedia-em-madrid' },
      blurb: 'From the Royal Palace and its Throne Room to Plaza de la Villa, Plaza Mayor and the Casa de la Panadería.' },
    { key: 'prado', title: 'Prado Museum Masterpieces',
      versions: { en: 'prado-museum-masterpieces' },
      blurb: "Eight masterpieces: Goya's Saturn and The Third of May, Bosch's Garden of Earthly Delights, Velázquez's Las Meninas and The Spinners, Titian, El Greco and Rubens." },
    { key: 'goya', title: "Goya's Secret Chapel: San Antonio de la Florida",
      versions: { en: 'goyas-secret-chapel-san-antonio-de-la-florida', es: 'la-capilla-secreta-de-goya-san-antonio-de-la-florida' },
      blurb: 'The small chapel Goya painted in 1798, its dome crowded with the people of Madrid around a miracle of Saint Anthony, and the painter’s own tomb.' },
  ],

  areas: [
    { name: 'Madrid de los Austrias', image: 'guide:palace', text: 'The old Habsburg centre, between the Royal Palace, Plaza de la Villa and Plaza Mayor.',
      guides: ['palace'] },
    { name: 'Paseo del Prado', image: 'guide:prado', text: 'The avenue of the great museums, UNESCO World Heritage since 2021 together with the Retiro park.',
      guides: ['prado'] },
    { name: 'San Antonio de la Florida', text: 'West of the palace, near the Manzanares river and Príncipe Pío station.',
      guides: ['goya'] },
  ],

  timeline: [
    { year: '1561', title: 'The court comes to Madrid', text: 'Philip II moves the royal court to Madrid, and a town becomes a capital.', guide: 'palace' },
    { year: '1619', title: 'Plaza Mayor', text: 'The great arcaded square is completed under Philip III.', guide: 'palace' },
    { year: '1734', title: 'The Alcázar burns', text: 'On Christmas Eve the old royal fortress burns down; the Royal Palace is built in its place.', guide: 'palace' },
    { year: '1798', title: "Goya's chapel", text: 'Goya paints the dome and walls of San Antonio de la Florida.', guide: 'goya' },
    { year: '1808', title: 'The uprising', text: "Madrid rises against Napoleon's troops on 2 May. Goya paints the executions of 3 May six years later.", guide: 'prado' },
    { year: '1819', title: 'The Prado opens', text: 'The royal collection goes on show to the public in the new museum on the Paseo del Prado.', guide: 'prado' },
  ],
  timelineTitle: ['Madrid in ', 'six moments'],

  plan: {
    title: ['One day in Madrid ', 'with our guides'],
    intro: 'All three guides fit in one full day: royal Madrid in the morning, the Prado in the afternoon, Goya’s chapel if you still have energy.',
    days: [
      { label: 'Morning', title: 'Royal Madrid', stops: [['palace', 'the palace, then Plaza Mayor']] },
      { label: 'Afternoon', title: 'The Prado', stops: [['prado', 'eight masterpieces']] },
      { label: 'Late afternoon', title: "Goya's chapel", stops: [['goya', 'west of the palace']] },
    ],
    tips: [
      ['Book ahead', 'The Royal Palace and the Prado can have long queues. Check times and book on their official sites.'],
      ['Mind the summer heat', 'Madrid summers are hot. Walk outdoors in the morning and keep the afternoon for the museum.'],
      ['Listen before you go in', 'Play the first stop of a museum guide before you enter, so you know what to look for.'],
      ['Download before you go', 'Download your guides over Wi-Fi. They play with no mobile data.'],
    ],
  },

  startAnswer: 'Start with Royal Palace & Plaza Mayor: it covers the palace, the Throne Room and the heart of old Madrid.',
};

export default madrid;
